import { useEffect } from 'react';

import { ActionCategory, PossibleAction } from '../../types/google-analytics-types.types';
import { pageTitle, replaceIdWithPath } from '../../types/page.types';
import { createGAEvent } from '../../utils/create-google-analytic-event.util';

export const useScrollDepth = () => {
  useEffect(() => {
    const scrollElement = document.getElementById('scrollbar-target');
    if (!scrollElement) return;

    const handleScroll = () => {
      const scrollDepth = (window.scrollY / scrollElement.scrollHeight) * 100;
      if (scrollDepth > 50) {
        createGAEvent({
          category: ActionCategory.SCROLLING,
          action: PossibleAction.SCROLLED_50,
          label: pageTitle[replaceIdWithPath(location.pathname)],
        });
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};
